export const BUTTONS = {
    pending : "Pending",
    approved : "Approved",
    rejected : "Rejected",
    export : "Export",
    import : "Import",
    new : "New",
    completed :'Completed',
    partial : 'Partial',
    Filter:'Filter'
}

export const PLACE_HOLDERS = {
    from : "From",
    to : "To",
    POsearch : 'PO No, PO Ref No, Amount',
    BillSearch: 'Bill No, Bill Ref No, Amount'
}

export const FILTER_TITLES = {
    START_DATE : 'Start Date',
    END_DATE : 'End Date',
    STATUS : 'Status',
    VENDOR : 'Vendor',
    VEHICLE_NO : 'Vehicle No',
    LR_NO : 'LR Number',
    BRANCH : 'Branch'
}